import React, { PureComponent } from 'react';
import Grid from '@material-ui/core/Grid';
import styled, { css } from 'styled-components';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';
import Button, { ButtonVariations } from '../SolvPatternLibrary/Button';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';
import FileUpload from '../SolvPatternLibrary/FileUpload';

const BaseCard = styled(Card)`
  width: 328px;
  height: 192px;
  border-radius: 12px;
  position: relative;
  box-shadow: none;
  margin: 15px auto;
`;

const StyledCard = styled(BaseCard)`
  text-align: center;
  overflow: visible;
  cursor: pointer;
  box-shadow: none;
  transition: opacity 200ms ease;
  ${({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    sc,
  }) => css`
    border: 1px ${sc.borderStyle} ${sc.borderColor || colors.black};
  `};
`;

const StyledCardPicture = styled(BaseCard)`
  background: ${colors.white}
    url(${(props) =>
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'CardProps & ... Remove this comment to see the full error message
      props.sc.imgData})
    no-repeat center;
  background-size: cover;
  overflow: hidden;
  opacity: ${({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'disabled' does not exist on type 'Themed... Remove this comment to see the full error message
    disabled,
  }) => (disabled ? 0.5 : 1)};
  -webkit-mask-image: -webkit-radial-gradient(white, black);
`;

const StyledCardHeader = styled(Typography)`
  margin-top: 20px;
  color: ${colors.fadeToBlack};
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.38px;
  line-height: 27px;
`;

const StyledCardBody = styled(Typography)`
  color: ${colors.mildGrey};
  margin: 20px auto 15px;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0.26px;
  line-height: 20px;
  width: 200px;
  text-align: center;
`;

const UploadButton = styled(Button)`
  width: 60%;
  height: 45px;
  padding: 0;
`;

const Spinner = styled(CircularProgress)`
  color: ${colors.crunchBerry};
  margin-left: 4px;
  vertical-align: sub;
`;

const StyledInput = styled(FileUpload)`
  width: 328px;
  height: 192px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.01;
  border: none;
  z-index: 10;
`;

const Uploading = styled.div`
  position: absolute;
  right: 10px;
  bottom: 10px;
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.fatherJohnMisty};
  padding: 2px 4px;
  background-color: rgba(100, 100, 100, 0.5);
  border-radius: 4px;
`;

const VIEW_PICTURE = 0;
const VIEW_PLACEHOLDER = 1;
const VIEW_BLANK = 2;

type Props = {
  cardImage?: string;
  onClick?: (...args: any[]) => any;
  showPlaceholder?: boolean;
  scanStarted?: boolean;
  scanCompleted?: boolean;
  handleFileChange: (...args: any[]) => any;
};

export default class InsuranceCard extends PureComponent<Props> {
  isCardUploading = () => {
    const { scanStarted, scanCompleted } = this.props;
    return scanStarted && !scanCompleted;
  };

  render() {
    const { cardImage, showPlaceholder, onClick, children, handleFileChange } = this.props;

    let view;
    if (cardImage) {
      view = VIEW_PICTURE;
    } else if (showPlaceholder) {
      view = VIEW_PLACEHOLDER;
    } else {
      view = VIEW_BLANK;
    }

    switch (view) {
      case VIEW_PLACEHOLDER:
        return (
          <StyledCard
            // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type '(IntrinsicAt... Remove this comment to see the full error message
            sc={{ borderStyle: 'dashed', borderColor: colors.lanaDelGrey }}
            elevation={0}
            onClick={onClick}
          >
            {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'type' does not exist on type 'IntrinsicA... Remove this comment to see the full error message */}
            <StyledInput type="file" accept={'image/*'} onChange={handleFileChange} />

            <Grid container justify="center">
              <Grid xs={12} item>
                <StyledCardHeader>{children}</StyledCardHeader>
              </Grid>

              <Grid xs={12} item>
                <StyledCardBody>
                  Place card on a flat surface and tap to take a picture.
                </StyledCardBody>
              </Grid>

              <Grid xs={12} item>
                <UploadButton variation={ButtonVariations.pinkTertiary}>Take a photo</UploadButton>
              </Grid>
            </Grid>
          </StyledCard>
        );
      case VIEW_PICTURE:
        return (
          // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type '(IntrinsicAt... Remove this comment to see the full error message
          <StyledCard sc={{ borderColor: 'none' }}>
            {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type '(IntrinsicAt... Remove this comment to see the full error message */}
            <StyledCardPicture sc={{ imgData: cardImage }} disabled={this.isCardUploading()} />

            <Fade in={this.isCardUploading()} appear unmountOnExit timeout={200}>
              <Uploading>
                Uploading <Spinner size={14} />
              </Uploading>
            </Fade>
          </StyledCard>
        );
      default:
      case VIEW_BLANK:
        // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type '(IntrinsicAt... Remove this comment to see the full error message
        return <StyledCard sc={{ borderStyle: 'dashed', borderColor: colors.lanaDelGrey }} />;
    }
  }
}
